import { CdkMenu, CdkMenuItem } from '@angular/cdk/menu';
import { Component, signal, ChangeDetectionStrategy } from '@angular/core';

import { MdwButton, MdwSplitButton } from '@spaces-ui/meadow/components/button';
import { MdwListItem } from '@spaces-ui/meadow/components/list-item';
import { Apple_Fill, Home_Fill, Plus } from '@spaces-ui/meadow/icons/svgs';

import { Sample } from '../../components';

@Component({
  selector: 'app-buttons',
  imports: [MdwButton, MdwSplitButton, MdwListItem, CdkMenu, CdkMenuItem, Sample],
  templateUrl: './buttons.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './buttons.scss',
})
export class Buttons {
  public icons = { Home_Fill, Apple_Fill, Plus };

  // Demo state for the --mdw-button-icon-transform sample.
  public rotated = signal(false);

  public toggleRotated() {
    this.rotated.update(r => !r);
  }

  // Demo state for the split button sample.
  public splitClicks = signal(0);

  public sendSplit() {
    this.splitClicks.update(count => count + 1);
  }
}
